import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FormFieldWrapperService {
  alerts$ = new BehaviorSubject<Array<any>>([]);

  public countErrors(errors: any[], model: any): { count: number; type: 'error' | 'warning'; } {
    const e: { count: number; type: 'error' | 'warning'; } = { count: 0, type: 'warning' };
    if (!model) {
      return e;
    }

    Object.keys(model).forEach(key => {
      if (typeof model[key] === 'object' && !Array.isArray(model[key])) {
        const result = this.countErrors(errors, model[key]);

        // Upgrade level to error if error is found
        if (result.type === 'error') {
          e.type = 'error';
        }

        e.count += result.count;
      } else if (Array.isArray(model[key])) {
        model[key].forEach(item => {
          const result = this.countErrors(errors, item);

          // Upgrade level to error if error is found
          if (result.type === 'error') {
            e.type = 'error';
          }

          e.count += result.count;
        });
      } else if (key === 'Id') {
        // Used filter instead of find, because there could be multiple errors with the same Id.
        const filteredErrors = errors.filter(i => i.id === model[key]);
        if (filteredErrors && filteredErrors.length > 0) {
          filteredErrors.forEach(error => {
            e.count++;
            if (error.type === 'error') {
              e.type = 'error';
            }
          });
        }
      }
    });

    return e;
  }
}
